import type { FC } from 'react';
import { useNormalizedStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { galleryListSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { GALLERY_SUBFOLDERS_STREAM } from '../../../../../constants';
import PremiumGalleryListItem from '../../items/PremiumGalleryListItem';
import BaseList from '../BaseList';

import s from './PremiumGalleryList.scss';

interface Props {}

const PremiumGalleryList: FC<Props> = () => {
  const { streamId, streamConfig, streamThrottle } = GALLERY_SUBFOLDERS_STREAM;
  const { items: galleries } = useNormalizedStream(
    streamId,
    galleryListSchema,
    streamThrottle,
    streamConfig
  );

  return (
    <BaseList
      className={s['list']}
      results={galleries}
      renderItem={gallery => <PremiumGalleryListItem key={gallery.folderId} gallery={gallery} />}
    />
  );
};
PremiumGalleryList.displayName = 'PremiumGalleryList';

export default PremiumGalleryList;
